$(document).ready(function () {
  if (document.documentElement.lang === 'fr-FR') {
    function toggle_modal_twistitime() {
      const firstVisit = sessionStorage.getItem("firstVisitTwistitime");

      if (!firstVisit) {
        open_modal_twistitime();
        sessionStorage.setItem("firstVisitTwistitime", "true");
      } else {
        close_modal_twistitime();
      }

      function open_modal_twistitime() {
        $("body").addClass("show_modal_twistitime noscroll");
      }

      function close_modal_twistitime() {
        $("body").removeClass("show_modal_twistitime noscroll");
      }

      $("body").on("click", ".modal_twistitime .close_modal, .modal_twistitime .overlay2", function (e) {
        e.preventDefault();
        close_modal_twistitime();
      });

      $("body").on("click", ".open_modal_twistitime", function (e) {
        e.preventDefault();
        open_modal_twistitime();
      });

      $("body").keyup(function (e) {
        e.preventDefault();
        if (e.keyCode == 27) {
          close_modal_twistitime();
        }
      });
    }

    toggle_modal_twistitime();
  }

  const $containerTwistiTimeForm = $('.modal_twistitime');

  document.addEventListener('submit', function(event) {
    if (event.target && event.target.matches("form#twistitime-inscription-form")) {
      handleRecallFormSubmit(event);
    }
  });

  function handleRecallFormSubmit(e) {
    e.preventDefault();

    let $formTwistiTime = $containerTwistiTimeForm.find('form'),
        $formTwistiTimeSubmitText = $formTwistiTime.find('button[type="submit"]').text()

    $formTwistiTime.find('.error-message').remove();
    $formTwistiTime.find('button').prop('disabled', true);
    $formTwistiTime.find('button').html($formTwistiTimeSubmitText + ' <i class="fas fa-spinner fa-spin"></i>');

    let formData = new FormData(),
      form = Object.fromEntries(new FormData(e.target));

    Object.keys(form).forEach(function (item) {
      formData.append(item, form[item]);
    });

    formData.append("action", "twistitime-submit");
    let params = new URLSearchParams(formData);

    fetch(urls.ajax, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
      },
      body: params,
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        $formTwistiTime.find('button').prop('disabled', false);
        $formTwistiTime.find('button').html($formTwistiTimeSubmitText);

        if ( ! response.success) {
          $formTwistiTime.replaceWith(response.data.form);
        } else {
          $formTwistiTime.replaceWith(`<div class="success--message text--center">${response.data.message}</div>`);
        }
      });
  }
});
